<!-- 自动监测站弹框 -->
<template>
  <div class="dialog-auto-monitor">
    <div class="header">
      <div class="title f-size-24 f-col-white08">{{ data.name }}
        <a v-if="data.name === '湾凼'" href="#" @click="checkSitePhoto">(现场照片)</a>
      </div>
      <div class="btn" @click="traceSource">污染溯源</div>
      <div class="btn btn-model" @click="toModel">
        模型预测
        <!-- <a href="http://172.21.92.37:19101/" target="_blank"></a> -->
      </div>
    </div>
    <div class="body">
      <div class="descriptions-item point">
        <span class="key">主要超标污染物:</span>
        <span class="value">{{ getYzCbBs(data.zywrwList) }}</span>
        <!-- <span class="value">总氮（监测值：1.248，超标倍数0.238）</span> -->
      </div>
      <div class="newest-parameter">
        <div class="title">
          <!-- {{ parameter.title }} -->
          最新水质参数（{{ data.dataTime ? data.dataTime : '-' }}）：
        </div>
        <div class="parameter">
          <div class="parameter-box">
            <div v-for="(item, index) in data.dataList" :key="index" class="data-box">
              <div class="box-content">
                <div class="value" :class="getFontSize(item.monitorValue)">
                  {{ item.monitorValue }}
                </div>
                <div class="key">{{ item.factorName }}</div>
              </div>
            </div>
          </div>
          <!-- <div class="data-box" v-for="(item, index) in parameter.data" :key="index">
            <div class="box-content">
              <div class="value">{{ getParameter(item.key) }}</div>
              <div class="key">{{ item.key }}</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="echart">
        <div class="header">
          <div class="left">
            <div v-for="(item, index) in data.factorList" :key="index" class="echart-btn"
              :class="{ active: selectFactor.factorCode === item.factorCode }" @click="select(item)">
              {{ item.factorName }}
            </div>
          </div>
          <div class="right">
            <div class="echart-btn" :class="{ active: echartTime === 'H' }" @click="select('H')">
              时均值
            </div>
            <div class="echart-btn" :class="{ active: echartTime === 'D' }" @click="select('D')">
              日均值
            </div>
            <n-date-picker v-model:value="startTime" size="small" type="date" clearable
              :on-update:formatted-value="changeTime" />
          </div>
        </div>
        <div class="body">
          <AutoMonitor ref="autoMonitor" />
        </div>
      </div>
    </div>
    <StationPhotoDialog ref="stationDialog"></StationPhotoDialog>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted, defineEmits } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import Bus from '@/config/Bus'
import AutoMonitor from '../charts/AutoMonitor.vue'
import StationPhotoDialog from '@/components/Dialog/StationPhotoDialog.vue'

const api = new Api()
const props = defineProps({
  data: Object,
})
const emit = defineEmits(['close'])

const autoMonitor = ref()
const options = []
const selectFactor = ref({})
const echartTime = ref('H')
const startTime = ref(new Date().getTime())
startTime.value = props.data.dataTime
  ? new Date(props.data.dataTime).getTime()
  : new Date().getTime()
const parameter = {
  title: '',
  data: [],
}
const model: any = ref(null)
// 模型预测
const toModel = () => {
  Bus.emit('showModal3')
}
const select = async (val) => {
  switch (val) {
    case 'H':
      echartTime.value = 'H'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    case 'D':
      echartTime.value = 'D'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    default:
      selectFactor.value = val
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName, {
      //   standValues: val.standValues,
      //   unit: val.unit,
      // });
      break
  }
}
const getFontSize = (value: any) => {
  let className = ''
  let val = value
  if (!value) {
    return className
  }
  if (typeof value === 'number') {
    val = `${value}`
  }
  if (val.length < 6) {
    className = 'font-size48'
  } else if (val.length < 10) {
    className = 'font-size40'
  } else {
    className = 'font-size34'
  }
  return className
}
// 获取echart趋势数据
const getTrend = async () => {
  let data = []
  await api.screen
    .getMonitorDataListUsingGet({
      begin: format(startTime.value),
      factor: selectFactor.value.factorCode,
      frequency: echartTime.value,
      mn: props.data.id,
    })
    .then((res) => {
      if (res.code == 200) {
        data = res.data
      }
    })
  const XData = []
  const YData = []
  for (let i = 0; i < data.length; i += 1) {
    XData.push(data[i].dataTime)
    YData.push(data[i].value)
  }
  // console.log(selectFactor.value)
  const markLine = {
    datumLine: selectFactor.value.standValues ? selectFactor.value.standValues[0] : null,
    unit: selectFactor.value.unit,
  }
  autoMonitor.value.initChart(XData, YData, selectFactor.value.factorName, markLine)
}
const getYzCbBs = (array: any[]) => {
  let res = '无'
  if (array && array.length) {
    res = ''
    array.forEach((item, index) => {
      if (index + 1 < array.length) {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}），`
      } else {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}）`
      }
    })
  }
  return res
}

const stationDialog = ref(null)
// TODO查看湾凼现场照片
const checkSitePhoto = (e: any) => {
  e.preventDefault()
  console.log(stationDialog.value, 'checkSitePhoto')
  if (stationDialog.value) {
    stationDialog.value.open()
  }
}

// 污染溯源
const traceSource = () => {
  console.log('数据aaa', props.data)
  emit('close')
  const data1 = {
    ...props.data,
  }
  Bus.emit('mapClick', {
    data: { ...data1, selectFactor: selectFactor.value.factorName },
    modalType: '污染溯源',
  })
}
const changeTime = () => {
  getTrend()
}

function add0(m) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  const time = new Date(shijianchuo)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  // var h = time.getHours();
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

onMounted(() => {
  // getTrend()
  select(props.data.factorList[0])
})
</script>

<style lang="scss" scoped>
.dialog-auto-monitor {
  width: 81.8rem;
  height: 54.35rem;

  .header {
    text-align: left;
    margin-bottom: 2rem;
    position: relative;

    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 3.15rem;
      line-height: 3.15rem;
    }

    .btn {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 6.2rem;
      text-align: center;
      font-size: 1.3rem;
      color: #ffffff;
      cursor: pointer;
      background: rgba(102, 146, 138, 0.1);
      border: 0.025rem solid #42c4dbcc;
      box-sizing: border-box;
      border-radius: 0.1rem;
    }

    .btn-model {
      a {
        text-decoration: none;
        color: white;
      }

      right: 6.4rem;
    }
  }

  .body {
    .point {
      font-size: 14px;
      line-height: 1.6rem;
      margin-bottom: 10px;

      .key {
        margin-right: 2rem;
      }

      .value {
        color: #fff825;
      }
    }

    .newest-parameter {
      margin-bottom: 3rem;

      .title {
        text-align: left;
        font-size: 14px;
        line-height: 1.6rem;
        margin-bottom: 1rem;
      }

      .parameter {
        display: flex;
        height: 8.2rem;
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        padding-bottom: 1.2rem;

        &::-webkit-scrollbar {
          display: block;
        }

        &::-webkit-scrollbar {
          height: 0.6rem;
        }

        /* 滚动槽 */
        &::-webkit-scrollbar-track {
          -webkit-box-shadow: rgba(13, 220, 227, 0.5);
          border-radius: 1rem;
        }

        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 1rem;
          background: rgba(13, 220, 227, 0.5);
          -webkit-box-shadow: rgba(13, 220, 227, 0.5);
        }

        &::-webkit-scrollbar-thumb:window-inactive {
          background: rgba(13, 220, 227, 0.5);
        }

        // justify-content: space-between;
        .parameter-box {
          display: flex;
        }

        // justify-content: space-between;
        .data-box {
          width: 80px;
          height: 82px;
          margin-right: 1.5rem;
          background-color: #68c1dc4d;
          padding: 0.675rem 0;
          box-sizing: border-box;
          text-align: center;

          .box-content {
            height: 5.35rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .value {
              color: #00ffe1;
              font-size: 2rem;
              height: 3.25rem;
              line-height: 3.25rem;
            }

            .key {
              font-size: 1.5rem;
              height: 2rem;
              line-height: 2rem;
              color: #ffffff;
            }
          }
        }
      }
    }

    .echart {
      * {
        font-size: 1.4rem;
      }

      .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 2rem;

        .left {

          // display: flex;
          .echart-btn {
            float: left;
            padding: 0 0.6rem;
            height: 2.65rem;
            line-height: 2.65rem;
            margin-right: 0.9rem;
            background-color: transparent;
            border: 0.025rem solid transparent;
            color: #8ec0ce;

            &:last-of-type {
              margin-right: 0;
            }
          }
        }

        .right {
          display: flex;

          .echart-btn {
            width: 5.6rem;
            height: 28px;
            line-height: 28px;
            font-size: 1.2rem;
            box-sizing: border-box;
            color: #ffffff99;
          }

          .map-dialog {
            width: 8.7rem;
            height: 2.4rem;
            line-height: 0;
            box-sizing: border-box;
            margin-left: 0.5rem;
          }
        }
      }

      .echart-btn {
        background: rgba(102, 146, 138, 0.1);
        border: 0.025rem solid rgba(102, 146, 138, 0.8);
        border-radius: 0.1rem;
        cursor: pointer;
        text-align: center;

        &.active,
        &:hover {
          background: #00acff !important;
          border: 0.025rem solid rgba(102, 146, 138, 0.8);
          color: #ffffff !important;
        }
      }
    }
  }

  .font-size48 {
    font-size: 2.4rem !important;
  }

  .font-size40 {
    font-size: 2rem !important;
  }

  .font-size34 {
    font-size: 1.7rem !important;
  }
}
</style>
